import React, { useState, useEffect } from "react";
import { Form, Button, Table } from "antd";
import { FormItemTypeEnum } from "../../../../components2/YhFormBox/Types"
import { YhFormItemsBox } from "../../../../components2/YhFormBox"
import useMdmModel from "../../../../model/mdmModel"
import { useNavModel } from "../../../../model/navModel";
import { DetailType } from "../../../../types/FmsEnums";
import { globalPrompt } from "../../../../components2/YhMessage"
import { useMaterielModel } from "../materielModel"
import { setTitle, forDictFind, filterArrId, Optios, loadDictParam } from "../../../../utils/utils"
import { IIMaterielSearch, IMaterielParams, IMaterielDetail, IMaterielInsert, IMaterielUpdate, IMaterielDisable, IMaterielRemove } from "../materielTypes"
import { DictEnum } from "../../../../types/MdmDIctEnum";

const MaterielDetail = () => {
    const [form] = Form.useForm();
    const { mdmCatalog, mdmBranch, mdmSourceApp, mdmOrgan, dict } = useMdmModel();
    const { selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav, findNav } = useNavModel()
    const { addParam, brandList, measurementList, materielTypeTree, selectedRow, setBrandList, setMeasurementList, setAddParam, updataAddParam, setSelectedRowKeys, setSelectedRow, updataEditParam, insertDetail, updataDetail, setMaterielTypeTree } = useMaterielModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const { id, pageParams: { mode, id: ids } } = modes

    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])

    useEffect(() => {
        setBrandList(loadDictParam(DictEnum.BRAND_NAME, dict))
        setMaterielTypeTree(forDictFind(DictEnum.MATERIAL_TYPE, dict)?.children ?? [])
        setMeasurementList(loadDictParam(DictEnum.UNIT, dict))
    }, [])

    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-2-1")
    //         const findEdit = findNav("2-2-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])

    const close = () => {
        replaceNav(selectedNavId, "2-2")
    }
    const onFinish = (values: IMaterielInsert | IMaterielUpdate) => {
        if (mode == DetailType.add) {
            insertDetail(values).then(res => {
                if (res) close()
            })
        } else if (mode == DetailType.edit) {
            updataDetail(values as IMaterielDetail).then(res => {
                if (res) close()
            })
        }
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "分支编码",
            labelCol: { span: 6 },
            fieldName: "branch",
            options: mdmBranch,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "版本号",
            labelCol: { span: 6 },
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.TreeSelect,
            span: 6,
            fieldLabel: "物料类型",
            labelCol: { span: 6 },
            fieldName: "typeCode",
            treeData: materielTypeTree,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        // {
        //     type: FormItemTypeEnum.Input,
        //     span: 6,
        //     fieldLabel: "物料类型编码",
        //     labelCol: { span: 6 },
        //     fieldName: "typeCode",
        // },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "品牌名称",
            labelCol: { span: 6 },
            fieldName: "brandCode",
            options: brandList
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "物料编码",
            labelCol: { span: 6 },
            fieldName: "code",
            disable: mode == DetailType.edit,
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "物料名称",
            labelCol: { span: 6 },
            fieldName: "name",
            rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "英文名称",
            labelCol: { span: 6 },
            fieldName: "nameEn",
            // rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "规格型号",
            labelCol: { span: 6 },
            fieldName: "model",
        },
        {
            type: FormItemTypeEnum.Select,
            span: 6,
            fieldLabel: "计量单位名称",
            labelCol: { span: 6 },
            fieldName: "unitCode",
            options: measurementList
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "产地",
            labelCol: { span: 6 },
            fieldName: "madeFrom",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "图号",
            labelCol: { span: 6 },
            fieldName: "replaceCode",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "最小起订量",
            labelCol: { span: 6 },
            fieldName: "minOrderNum",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 12,
            fieldLabel: "备注",
            labelCol: { span: 3 },
            fieldName: "note",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "厂家编码",
            labelCol: { span: 6 },
            fieldName: "factoryCode",
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 6,
            valuePropName: "checked",
            fieldLabel: "状态",
            labelCol: { span: 6 },
            fieldName: "enable",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        }
    ]
    const items1 = [
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "采购价",
            labelCol: { span: 6 },
            fieldName: "purchasePrice",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "销售批发价",
            labelCol: { span: 6 },
            fieldName: "wholesalePrice",
        },
        {
            type: FormItemTypeEnum.Input,
            span: 6,
            fieldLabel: "销售零售价格",
            labelCol: { span: 6 },
            fieldName: "retailPrice",
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}物料管理</div>
    const title1 = <div className="font-bold font-size-lg">商品价格</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({})
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({ code: selectedRow[0].code })
            setSelectedRow([{ code: selectedRow[0].code }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action} IclassName="p-20" />
        <YhFormItemsBox disabled={mode == DetailType.look} items={items1} title={title1} IclassName="p-20" />

    </Form>
}
export default MaterielDetail